// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicyBox":"recaptcha-branding_privacyPolicyBox__h3HAK","culturePopup":"recaptcha-branding_culturePopup___9oUv"};